import type { TranscriptRow } from "./ui-types";

export type LiveTranscriptEventType = "transcript.delta" | "transcript.commit";

export function orderTranscriptRows(rows: readonly TranscriptRow[]): TranscriptRow[] {
  return [...rows]
    .sort(
      (left, right) =>
        left.line - right.line ||
        left.startMs - right.startMs ||
        left.id.localeCompare(right.id)
    )
    .map((row, index) => ({ ...row, line: index + 1 }));
}

/**
 * Applies replayable live transcript events without duplicating provisional or
 * committed rows. Replayed events after reconnect therefore remain idempotent.
 */
export function applyLiveTranscriptEvent(
  current: readonly TranscriptRow[],
  event: {
    type: LiveTranscriptEventType;
    row: TranscriptRow;
    provisionalRowId?: string;
  }
): TranscriptRow[] {
  const next = current.filter(
    (candidate) =>
      candidate.id !== event.row.id &&
      candidate.id !== event.provisionalRowId
  );
  return orderTranscriptRows([
    ...next,
    {
      ...event.row,
      provisional: event.type === "transcript.delta"
    }
  ]);
}
